import { LoadType } from '@tencent/ark-extensions';

/**
 * 所有品类都会用到的公共逻辑
 * 页面加载完后调用执行即可，目前在非编 dc 组件初始化完成后统一调用
 */
export const COMMON_LOADER_CONFIG = {
    name: 'docs-component-common-loader',
    loadType: LoadType.EAGER,
};

